import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { QuickViewComponent } from "../../modal/quick-view/quick-view.component";
import { CartModalComponent } from "../../modal/cart-modal/cart-modal.component";
import { Product } from "../../../classes/product";
import { ProductService } from "../../../services/product.service";
import { log } from 'console';
import { GoogleAnalyticsService } from '../../../../shared/services/google-analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-box-two',
  templateUrl: './product-box-two.component.html',
  styleUrls: ['./product-box-two.component.scss']
})
export class ProductBoxTwoComponent implements OnInit {

  @Input() product: Product;
  @Input() currency: any = this.productService.Currency; // Default Currency
  @Input() cartModal: boolean = false; // Default False
  
  @ViewChild("quickView") QuickView: QuickViewComponent;
  @ViewChild("cartModal") CartModal: CartModalComponent;

  public ImageSrc : string
  public variante;
  public userName: any;
  
  constructor(private productService: ProductService, private route: ActivatedRoute,
    private analytics: GoogleAnalyticsService) {}

  ngOnInit(): void {
    
    if (this.product && this.product.discount != null) {
    this.product.discount = Math.trunc(this.product.discount);
  }
    this.userName = JSON.parse(sessionStorage.getItem("user"))?.userName || 'invitado@GIGMAX.com';         
  }

  // Get Product Color

  Color(variants) {
    const uniqColor = [];
  
    // Verificar que variants no sea null ni undefined y sea un array
    if (Array.isArray(variants)) {
      for (let i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].color && uniqColor.indexOf(variants[i].color) === -1) {
          uniqColor.push(variants[i].color);
        }
      }
    }
  
    return uniqColor;
  }

  // Change Variants
  ChangeVariants(color, product) {
    product.variants.map((item) => {
      if (item.color === color) {
        this.variante = item.variant_id;
        product.images.map((img) => {
          if (img.image_id === item.image_id) {
            this.ImageSrc = img.src;
          }
        })
      }
    })
  }

  ChangeVariantsImage(src) {
    this.ImageSrc = src;
  }

  addToCart(product: any) {
    
    product.quantity = 1;
    product.id = product.variants[0].id;
    product.stock = product.variants[0].stock;
    product.sku = product.variants[0].sku;
    product.color = product.variants[0].color;
    product.size = product.variants[0].size;
    product.image = product.variants[0].images[0];
    
    this.productService.addToCart(product);
    this.analytics.sendEvent('add_to_cart', {
      idEvento: 4,
      currency: 'MXN',
      userName: this.userName,
      value: product.price,
      items: [
        {
          item_name: product.title,
          item_id: product.id,
          price: product.price,
          quantity: 1,
        },
      ],
    });

  }
  

  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  addToCompare(product: any) {
    this.productService.addToCompare(product);
  }

    getProveedorColorClass(): string {
    switch (this.product.productoProveedor) {
      case 'Fulfil':
        return 'tag-fulfil';
      case 'FRDX':
        return 'tag-frdx';
      case 'AntenaBay':
        return 'tag-antenabay';
      default:
        return '';
    }
  }
  
}
